/**
 * Стильные иконки Lucide для дашборда и интерфейса.
 * Назначение: единая точка импорта иконок в стиле shadcn/ui.
 * Вход: нет. Выход: именованные экспорты компонентов иконок.
 */
import {
  Users,
  User,
  BarChart3,
  Wallet,
  Target,
  Search,
  Phone,
  FileText,
  Briefcase,
  Home,
  Settings,
  Palette,
  CheckCircle,
  XCircle,
  RefreshCw,
  List,
  Lightbulb,
  Link2,
  ArrowRight,
  Hourglass,
  Smartphone,
  Save,
  Heart,
  Star,
  Building2,
  ArrowLeftRight,
  TrendingUp,
  TrendingDown,
  Menu,
  X,
  Calendar,
  MessageCircle,
  BookOpen,
  Sun,
  Moon,
  Coins,
  DollarSign,
  Euro,
  CircleDollarSign,
  Download,
  Eye,
  Lock,
  Plus,
  Pause,
  Play,
  PlayCircle,
  Trash2,
  Rocket,
  Crown,
  Bot,
  Zap,
  TestTube,
  Database,
  Copy,
  Check,
} from 'lucide-react';

export {
  Users,
  User,
  BarChart3,
  Wallet,
  Target,
  Search,
  Phone,
  FileText,
  Briefcase,
  Home,
  Settings,
  Palette,
  CheckCircle,
  XCircle,
  RefreshCw,
  List,
  Lightbulb,
  Link2,
  ArrowRight,
  Hourglass,
  Smartphone,
  Save,
  Heart,
  Star,
  Building2,
  ArrowLeftRight,
  TrendingUp,
  TrendingDown,
  Menu,
  X,
  Calendar,
  MessageCircle,
  BookOpen,
  Sun,
  Moon,
  Coins,
  DollarSign,
  Euro,
  CircleDollarSign,
  Download,
  Eye,
  Lock,
  Plus,
  Pause,
  Play,
  PlayCircle,
  Trash2,
  Rocket,
  Crown,
  Bot,
  Zap,
  TestTube,
  Database,
  Copy,
  Check,
};

/** Иконки для карточек статистики по ключу */
export const statIcons = {
  clients: Users,
  deals: BarChart3,
  turnover: Wallet,
  average: Target,
};
